export default __webpack_public_path__ + "static/media/0.2cf4eaf6.png";